import {useFlagVariation} from '@customink/signalmizely-react';

// Summer T-shirt promo flag key
export const SUMMER_T_SHIRT_PROMO_TEST_KEY = 'sitewide_august_tshirts_promo';

// PDP Elevated Product Info Test
export const PDP_ELEVATED_PRODUCT_INFO_TEST_KEY =
  'pc_pdp_elevated_product_information_test';

// Mobile color swatches test key
export const MOBILE_COLOR_SWATCHES_TEST_KEY =
  'pc_catalog_mobile_color_swatches_v2';

export const useFeatureFlag = (flagName) => {
  // {error, isLoading, variation} tuple
  return useFlagVariation(flagName);
};

export const featureFlagNotEligible = () => {
  return {error: null, isLoading: false, variation: null};
};
